"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCore = exports.CoreProvider = void 0;
var CoreProvider_1 = __importDefault(require("./CoreProvider"));
exports.CoreProvider = CoreProvider_1.default;
var useCore_1 = __importDefault(require("./useCore"));
exports.useCore = useCore_1.default;
